<template>
  <v-card max-width="500" class="mx-auto elevation-0" color="transparent">
    <v-card-title
      class="justify-center"
    >
      <v-img
        :src="require('@/assets/undraw_personal_email_t7nw.svg')"
        height="100"
        contain
      ></v-img>
      Coordonnées
    </v-card-title>

    <v-form ref="contactForm" @submit.prevent>
      <v-expansion-panels v-model="activePanelIndex" :readonly="isSaving">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col cols="4">
                  Adresse e-mail
                </v-col>
                <v-col
                  cols="8"
                  class="text--secondary"
                >
                  <v-fade-transition leave-absolute>
                    <span
                      v-if="open"
                      key="0"
                    >
                      Modifier votre adresse e-mail
                    </span>
                    <span
                      v-else
                      key="1"
                    >
                      {{ user.email }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4" >
                <v-text-field
                  label="Adresse e-mail"
                  v-model="email"
                  :rules="rules.email"
                  validate-on-blur
                  :error-messages="emailErrorText"
                  @change="emailErrorText = ''"
                  type="email"
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="changeEmail()"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-row no-gutters>
              <v-col cols="4">
                N° de téléphone
              </v-col>
              <v-col
                cols="8"
                class="text--secondary"
              >
                <v-fade-transition leave-absolute>
                  <span
                    v-if="open"
                    key="0"
                  >
                    Modifier votre n° de téléphone
                  </span>
                  <span
                    v-else
                    key="1"
                  >
                    {{ user.mobile }}
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4" >
                <v-text-field
                  label="N° de téléphone"
                  v-model="mobile"
                  :rules="rules.mobile"
                  validate-on-blur
                  type="tel"
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ tel: mobile })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rulesMixin from '@/mixins/rulesMixin';

const axios = require('axios').default;

export default {
  name: 'ProfileContact',

  mixins: [rulesMixin],

  data: () => ({
    email: '',
    emailErrorText: '',
    mobile: '',
    activePanelIndex: undefined,
    isSaving: false,
  }),

  computed: {
    ...mapState(['user']),
  },

  methods: {
    ...mapActions(['updateUserData']),

    close() {
      this.activePanelIndex = undefined;
    },

    modify(data) {
      if (!this.$refs.contactForm.validate()) return;
      this.isSaving = true;
      this.updateUserData(data)
        .then(() => {
          this.close();
        })
        .catch(() => {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Erreur lors de la modification du profil',
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },

    async changeEmail() {
      try {
        if (!this.$refs.contactForm.validate()) return;
        this.isSaving = true;
        // eslint-disable-next-line prefer-destructuring
        const email = this.email;
        const response = await axios.post('change_email', { email });
        if (response.data === 'Adresse email déjà existante') {
          this.emailErrorText = 'Cette adresse email est déjà prise';
        } else if (response.data === 'Ok email envoyé') {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: `Un e-mail a été envoyé sur ${email}. Confirmez pour valider le changement`,
          });
          this.close();
        } else {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Impossible de changer l\'adresse email',
          });
        }
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Erreur lors de la modification de l\'adresse e-mail est survenue',
        });
      } finally {
        this.isSaving = false;
      }
    },
  },

  watch: {
    activePanelIndex() {
      this.email = this.user.email;
      this.mobile = this.user.mobile;
      this.$refs.contactForm.resetValidation();
      this.emailErrorText = '';
    },
  },
};
</script>
